import { TreeItemProps } from '@mui/x-tree-view/TreeItem'
import React from 'react'

import { ConcurrentTreeItem } from 'components/scenarios/concurrent/ConcurrentTreeItem'
import theme from 'theme'

export const ConcurrentTreeNodesRoot: React.FC<
  {
    label: React.ReactNode
    nodeId?: string
    icon?: React.ReactNode
  } & TreeItemProps
> = ({ label, nodeId = '1', icon, children, ...rest }) => {
  return (
    <ConcurrentTreeItem
      collapseIcon={icon}
      css={{
        margin: `${theme.space[3]}px 0` // TODO why isn't this getting passed on?
      }}
      expandIcon={icon}
      label={label}
      nodeId={nodeId}
      {...rest}
    >
      {children}
    </ConcurrentTreeItem>
  )
}
